/* tslint:disable */
/* eslint-disable */
/**
 * Bookingkit Api v4
 * Specification of Bookingkit Api v4
 *
 * The version of the OpenAPI document: 0.19.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI } from '../base';
/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create label
         * @param {string} supplierId
         * @param {CreateLabelRequest} createLabelRequest A required query parameter to set the new label name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLabel: (supplierId, createLabelRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('createLabel', 'supplierId', supplierId);
            // verify required parameter 'createLabelRequest' is not null or undefined
            assertParamExists('createLabel', 'createLabelRequest', createLabelRequest);
            const localVarPath = `/suppliers/{supplierId}/labels`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", ["event", "event:write"], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createLabelRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Search orders with a query building pattern
         * @param {string} supplierId
         * @param {CustomSearchOrderRequest} customSearchOrderRequest An array of BSQL objects
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customSearchOrder: (supplierId, customSearchOrderRequest, pageSize, asc, nextPageToken, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('customSearchOrder', 'supplierId', supplierId);
            // verify required parameter 'customSearchOrderRequest' is not null or undefined
            assertParamExists('customSearchOrder', 'customSearchOrderRequest', customSearchOrderRequest);
            const localVarPath = `/suppliers/{supplierId}/orders/search`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (asc !== undefined) {
                localVarQueryParameter['asc'] = asc;
            }
            if (nextPageToken !== undefined) {
                localVarQueryParameter['next_page_token'] = nextPageToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(customSearchOrderRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete label
         * @param {string} supplierId
         * @param {string} labelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLabel: (supplierId, labelId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('deleteLabel', 'supplierId', supplierId);
            // verify required parameter 'labelId' is not null or undefined
            assertParamExists('deleteLabel', 'labelId', labelId);
            const localVarPath = `/suppliers/{supplierId}/labels/{labelId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"labelId"}}`, encodeURIComponent(String(labelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", ["event", "event:write"], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * `account_status` can be one of the following:      *  - `ACTIVE`: The supplier is active and fully operative.      *  - `INCOMPLETE`: The supplier account is canceled. The account can be still accessed with limited functionalities.      *  - `CANCELED`: The supplier account is missing some required information. Until the status does not switch to active, this account has limited functionalities and can not receive orders.
         * @summary Gets current supplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserSupplier: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/me/supplier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get total number of tickets for orders per day. Only orders with status: accepted, requested and reserved. Only active or requested tickets are counted.
         * @param {string} supplierId
         * @param {GetOrderStatsTicketCountRequest} getOrderStatsTicketCountRequest The filters to get the stats for
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [sortBy]
         * @param {string} [nextPageToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderStatsTicketCount: (supplierId, getOrderStatsTicketCountRequest, pageSize, asc, sortBy, nextPageToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getOrderStatsTicketCount', 'supplierId', supplierId);
            // verify required parameter 'getOrderStatsTicketCountRequest' is not null or undefined
            assertParamExists('getOrderStatsTicketCount', 'getOrderStatsTicketCountRequest', getOrderStatsTicketCountRequest);
            const localVarPath = `/suppliers/{supplierId}/orders/stats/tickets/count`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (asc !== undefined) {
                localVarQueryParameter['asc'] = asc;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (nextPageToken !== undefined) {
                localVarQueryParameter['next_page_token'] = nextPageToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getOrderStatsTicketCountRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get tickets value for orders per day
         * @param {string} supplierId
         * @param {GetOrderStatsTicketValueRequest} getOrderStatsTicketValueRequest The filters to get the stats for
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [sortBy]
         * @param {string} [nextPageToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderStatsTicketValue: (supplierId, getOrderStatsTicketValueRequest, pageSize, asc, sortBy, nextPageToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('getOrderStatsTicketValue', 'supplierId', supplierId);
            // verify required parameter 'getOrderStatsTicketValueRequest' is not null or undefined
            assertParamExists('getOrderStatsTicketValue', 'getOrderStatsTicketValueRequest', getOrderStatsTicketValueRequest);
            const localVarPath = `/suppliers/{supplierId}/orders/stats/tickets/values`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (asc !== undefined) {
                localVarQueryParameter['asc'] = asc;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (nextPageToken !== undefined) {
                localVarQueryParameter['next_page_token'] = nextPageToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getOrderStatsTicketValueRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersMe: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get a widget
         * @param {string} widgetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidget: (widgetId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'widgetId' is not null or undefined
            assertParamExists('getWidget', 'widgetId', widgetId);
            const localVarPath = `/widgets/{widgetId}`
                .replace(`{${"widgetId"}}`, encodeURIComponent(String(widgetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List all apps
         * @param {string} supplierId
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApps: (supplierId, pageSize, asc, nextPageToken, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('listApps', 'supplierId', supplierId);
            const localVarPath = `/suppliers/{supplierId}/apps`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (asc !== undefined) {
                localVarQueryParameter['asc'] = asc;
            }
            if (nextPageToken !== undefined) {
                localVarQueryParameter['next_page_token'] = nextPageToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List experience\'s availabilities
         * @param {string} supplierId
         * @param {string} experienceId
         * @param {string} localStartTime
         * @param {string} [localEndTime]
         * @param {string} [_options]
         * @param {string} [deltaSince]
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExperienceAvailabilities: (supplierId, experienceId, localStartTime, localEndTime, _options, deltaSince, pageSize, asc, nextPageToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('listExperienceAvailabilities', 'supplierId', supplierId);
            // verify required parameter 'experienceId' is not null or undefined
            assertParamExists('listExperienceAvailabilities', 'experienceId', experienceId);
            // verify required parameter 'localStartTime' is not null or undefined
            assertParamExists('listExperienceAvailabilities', 'localStartTime', localStartTime);
            const localVarPath = `/suppliers/{supplierId}/inventory/experiences/{experienceId}/availabilities`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"experienceId"}}`, encodeURIComponent(String(experienceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            if (localStartTime !== undefined) {
                localVarQueryParameter['local_start_time'] = localStartTime;
            }
            if (localEndTime !== undefined) {
                localVarQueryParameter['local_end_time'] = localEndTime;
            }
            if (_options !== undefined) {
                localVarQueryParameter['options'] = _options;
            }
            if (deltaSince !== undefined) {
                localVarQueryParameter['delta_since'] = deltaSince;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (asc !== undefined) {
                localVarQueryParameter['asc'] = asc;
            }
            if (nextPageToken !== undefined) {
                localVarQueryParameter['next_page_token'] = nextPageToken;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List experiences
         * @param {string} supplierId
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExperiences: (supplierId, pageSize, asc, nextPageToken, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('listExperiences', 'supplierId', supplierId);
            const localVarPath = `/suppliers/{supplierId}/inventory/experiences`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (asc !== undefined) {
                localVarQueryParameter['asc'] = asc;
            }
            if (nextPageToken !== undefined) {
                localVarQueryParameter['next_page_token'] = nextPageToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List labels
         * @param {string} supplierId
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabels: (supplierId, pageSize, asc, nextPageToken, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('listLabels', 'supplierId', supplierId);
            const localVarPath = `/suppliers/{supplierId}/labels`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (asc !== undefined) {
                localVarQueryParameter['asc'] = asc;
            }
            if (nextPageToken !== undefined) {
                localVarQueryParameter['next_page_token'] = nextPageToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List all modules
         * @param {string} supplierId
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listModules: (supplierId, pageSize, asc, nextPageToken, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('listModules', 'supplierId', supplierId);
            const localVarPath = `/suppliers/{supplierId}/modules/list`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (asc !== undefined) {
                localVarQueryParameter['asc'] = asc;
            }
            if (nextPageToken !== undefined) {
                localVarQueryParameter['next_page_token'] = nextPageToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List available suppliers
         * @param {string} [nameContains] An optional query parameter to filter the list
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSuppliers: (nameContains, pageSize, asc, nextPageToken, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/suppliers/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            if (nameContains !== undefined) {
                localVarQueryParameter['nameContains'] = nameContains;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (asc !== undefined) {
                localVarQueryParameter['asc'] = asc;
            }
            if (nextPageToken !== undefined) {
                localVarQueryParameter['next_page_token'] = nextPageToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Transactions|List for wallet
         * @param {string} supplierId
         * @param {string} walletId
         * @param {string} [types]
         * @param {string} [from]
         * @param {string} [to]
         * @param {string} [nextPageToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransactions: (supplierId, walletId, types, from, to, nextPageToken, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('listTransactions', 'supplierId', supplierId);
            // verify required parameter 'walletId' is not null or undefined
            assertParamExists('listTransactions', 'walletId', walletId);
            const localVarPath = `/suppliers/{supplierId}/payment-providers/wallets/{walletId}/transactions`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"walletId"}}`, encodeURIComponent(String(walletId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            if (types !== undefined) {
                localVarQueryParameter['types'] = types;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (nextPageToken !== undefined) {
                localVarQueryParameter['next_page_token'] = nextPageToken;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List widget\'s experiences
         * @param {string} widgetId
         * @param {string} [experienceIds]
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWidgetExperiences: (widgetId, experienceIds, pageSize, asc, nextPageToken, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'widgetId' is not null or undefined
            assertParamExists('listWidgetExperiences', 'widgetId', widgetId);
            const localVarPath = `/widgets/{widgetId}/experiences`
                .replace(`{${"widgetId"}}`, encodeURIComponent(String(widgetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (experienceIds !== undefined) {
                localVarQueryParameter['experienceIds'] = experienceIds;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (asc !== undefined) {
                localVarQueryParameter['asc'] = asc;
            }
            if (nextPageToken !== undefined) {
                localVarQueryParameter['next_page_token'] = nextPageToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List widget\'s experiences availabilities
         * @param {string} widgetId
         * @param {string} experienceId
         * @param {string} localStartTime
         * @param {string} [localEndTime]
         * @param {string} [_options]
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWidgetExperiencesAvailabilities: (widgetId, experienceId, localStartTime, localEndTime, _options, pageSize, asc, nextPageToken, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'widgetId' is not null or undefined
            assertParamExists('listWidgetExperiencesAvailabilities', 'widgetId', widgetId);
            // verify required parameter 'experienceId' is not null or undefined
            assertParamExists('listWidgetExperiencesAvailabilities', 'experienceId', experienceId);
            // verify required parameter 'localStartTime' is not null or undefined
            assertParamExists('listWidgetExperiencesAvailabilities', 'localStartTime', localStartTime);
            const localVarPath = `/widgets/{widgetId}/experiences/{experienceId}/availabilities`
                .replace(`{${"widgetId"}}`, encodeURIComponent(String(widgetId)))
                .replace(`{${"experienceId"}}`, encodeURIComponent(String(experienceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (localStartTime !== undefined) {
                localVarQueryParameter['local_start_time'] = localStartTime;
            }
            if (localEndTime !== undefined) {
                localVarQueryParameter['local_end_time'] = localEndTime;
            }
            if (_options !== undefined) {
                localVarQueryParameter['options'] = _options;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (asc !== undefined) {
                localVarQueryParameter['asc'] = asc;
            }
            if (nextPageToken !== undefined) {
                localVarQueryParameter['next_page_token'] = nextPageToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Allows to edit an availability object
         * @param {string} supplierId
         * @param {string} experienceId
         * @param {string} availabilityId
         * @param {PatchAvailabilityRequest} patchAvailabilityRequest The fields and values to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchExperienceAvailability: (supplierId, experienceId, availabilityId, patchAvailabilityRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('patchExperienceAvailability', 'supplierId', supplierId);
            // verify required parameter 'experienceId' is not null or undefined
            assertParamExists('patchExperienceAvailability', 'experienceId', experienceId);
            // verify required parameter 'availabilityId' is not null or undefined
            assertParamExists('patchExperienceAvailability', 'availabilityId', availabilityId);
            // verify required parameter 'patchAvailabilityRequest' is not null or undefined
            assertParamExists('patchExperienceAvailability', 'patchAvailabilityRequest', patchAvailabilityRequest);
            const localVarPath = `/suppliers/{supplierId}/inventory/experiences/{experienceId}/availabilities/{availabilityId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"experienceId"}}`, encodeURIComponent(String(experienceId)))
                .replace(`{${"availabilityId"}}`, encodeURIComponent(String(availabilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(patchAvailabilityRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List of payment options of the supplier
         * @param {string} supplierId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentOptionsGet: (supplierId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('paymentOptionsGet', 'supplierId', supplierId);
            const localVarPath = `/suppliers/{supplierId}/checkout-configuration/payment-options`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List of PaymentProviders of the supplier
         * @param {string} supplierId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentProviders: (supplierId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('paymentProviders', 'supplierId', supplierId);
            const localVarPath = `/suppliers/{supplierId}/payment-providers`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Payout money from a wallet
         * @param {string} supplierId
         * @param {string} walletId
         * @param {CreatePayoutRequest} createPayoutRequest The fields and values to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutCreateV2: (supplierId, walletId, createPayoutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('payoutCreateV2', 'supplierId', supplierId);
            // verify required parameter 'walletId' is not null or undefined
            assertParamExists('payoutCreateV2', 'walletId', walletId);
            // verify required parameter 'createPayoutRequest' is not null or undefined
            assertParamExists('payoutCreateV2', 'createPayoutRequest', createPayoutRequest);
            const localVarPath = `/suppliers/{supplierId}/payment-providers/wallets/{walletId}/payout/V2`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"walletId"}}`, encodeURIComponent(String(walletId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createPayoutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a payout destination
         * @param {string} supplierId
         * @param {string} walletId
         * @param {CreatePayoutDestinationRequest} createPayoutDestinationRequest The fields and values to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutDestinationCreate: (supplierId, walletId, createPayoutDestinationRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('payoutDestinationCreate', 'supplierId', supplierId);
            // verify required parameter 'walletId' is not null or undefined
            assertParamExists('payoutDestinationCreate', 'walletId', walletId);
            // verify required parameter 'createPayoutDestinationRequest' is not null or undefined
            assertParamExists('payoutDestinationCreate', 'createPayoutDestinationRequest', createPayoutDestinationRequest);
            const localVarPath = `/suppliers/{supplierId}/payment-providers/wallets/{walletId}/payout-destinations`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"walletId"}}`, encodeURIComponent(String(walletId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createPayoutDestinationRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete payout destination
         * @param {string} supplierId
         * @param {string} walletId
         * @param {string} payoutDestinationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutDestinationDelete: (supplierId, walletId, payoutDestinationId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('payoutDestinationDelete', 'supplierId', supplierId);
            // verify required parameter 'walletId' is not null or undefined
            assertParamExists('payoutDestinationDelete', 'walletId', walletId);
            // verify required parameter 'payoutDestinationId' is not null or undefined
            assertParamExists('payoutDestinationDelete', 'payoutDestinationId', payoutDestinationId);
            const localVarPath = `/suppliers/{supplierId}/payment-providers/wallets/{walletId}/payout-destinations/{payoutDestinationId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"walletId"}}`, encodeURIComponent(String(walletId)))
                .replace(`{${"payoutDestinationId"}}`, encodeURIComponent(String(payoutDestinationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List payout destinations
         * @param {string} supplierId
         * @param {string} walletId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutDestinationList: (supplierId, walletId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('payoutDestinationList', 'supplierId', supplierId);
            // verify required parameter 'walletId' is not null or undefined
            assertParamExists('payoutDestinationList', 'walletId', walletId);
            const localVarPath = `/suppliers/{supplierId}/payment-providers/wallets/{walletId}/payout-destinations`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"walletId"}}`, encodeURIComponent(String(walletId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Search coupons
         * @param {string} supplierId
         * @param {string} query
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCoupons: (supplierId, query, pageSize, asc, nextPageToken, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('searchCoupons', 'supplierId', supplierId);
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchCoupons', 'query', query);
            const localVarPath = `/suppliers/{supplierId}/coupons/search`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (asc !== undefined) {
                localVarQueryParameter['asc'] = asc;
            }
            if (nextPageToken !== undefined) {
                localVarQueryParameter['next_page_token'] = nextPageToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Search orders
         * @param {string} supplierId
         * @param {string} query
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {SearchOrdersSortByEnum} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrders: (supplierId, query, pageSize, asc, nextPageToken, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('searchOrders', 'supplierId', supplierId);
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchOrders', 'query', query);
            const localVarPath = `/suppliers/{supplierId}/orders/search`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (asc !== undefined) {
                localVarQueryParameter['asc'] = asc;
            }
            if (nextPageToken !== undefined) {
                localVarQueryParameter['next_page_token'] = nextPageToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Search vouchers
         * @param {string} supplierId
         * @param {string} query
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVouchers: (supplierId, query, pageSize, asc, nextPageToken, sortBy, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('searchVouchers', 'supplierId', supplierId);
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchVouchers', 'query', query);
            const localVarPath = `/suppliers/{supplierId}/vouchers/search`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }
            if (asc !== undefined) {
                localVarQueryParameter['asc'] = asc;
            }
            if (nextPageToken !== undefined) {
                localVarQueryParameter['next_page_token'] = nextPageToken;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Sets current user supplier
         * @param {string} ident A required query parameter to set the new user supplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCurrentUserSupplier: (ident, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ident' is not null or undefined
            assertParamExists('setCurrentUserSupplier', 'ident', ident);
            const localVarPath = `/users/me/supplier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            if (ident !== undefined) {
                localVarQueryParameter['ident'] = ident;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Set payment options for the checkout
         * @param {string} supplierId
         * @param {SetPaymentOptionsRequest} setPaymentOptionsRequest A list of payment options to toggle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPaymentOptions: (supplierId, setPaymentOptionsRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('setPaymentOptions', 'supplierId', supplierId);
            // verify required parameter 'setPaymentOptionsRequest' is not null or undefined
            assertParamExists('setPaymentOptions', 'setPaymentOptionsRequest', setPaymentOptionsRequest);
            const localVarPath = `/suppliers/{supplierId}/checkout-configuration/payment-options`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(setPaymentOptionsRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Schedule the switch of payment provider
         * @param {string} supplierId
         * @param {string} providerId
         * @param {SetActivationIntent} setActivationIntent Setting for switching the payment provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchPaymentProviders: (supplierId, providerId, setActivationIntent, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('switchPaymentProviders', 'supplierId', supplierId);
            // verify required parameter 'providerId' is not null or undefined
            assertParamExists('switchPaymentProviders', 'providerId', providerId);
            // verify required parameter 'setActivationIntent' is not null or undefined
            assertParamExists('switchPaymentProviders', 'setActivationIntent', setActivationIntent);
            const localVarPath = `/suppliers/{supplierId}/payment-providers/{providerId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"providerId"}}`, encodeURIComponent(String(providerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(setActivationIntent, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update label
         * @param {string} supplierId
         * @param {string} labelId
         * @param {UpdateLabelRequest} updateLabelRequest A required query parameter to update an existing label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLabel: (supplierId, labelId, updateLabelRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('updateLabel', 'supplierId', supplierId);
            // verify required parameter 'labelId' is not null or undefined
            assertParamExists('updateLabel', 'labelId', labelId);
            // verify required parameter 'updateLabelRequest' is not null or undefined
            assertParamExists('updateLabel', 'updateLabelRequest', updateLabelRequest);
            const localVarPath = `/suppliers/{supplierId}/labels/{labelId}`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)))
                .replace(`{${"labelId"}}`, encodeURIComponent(String(labelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", ["event", "event:write"], configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateLabelRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Wallets|List by supplier
         * @param {string} supplierId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wallets: (supplierId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('wallets', 'supplierId', supplierId);
            const localVarPath = `/suppliers/{supplierId}/payment-providers/wallets`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Wallets|List by supplier
         * @param {string} supplierId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        walletsV2: (supplierId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'supplierId' is not null or undefined
            assertParamExists('walletsV2', 'supplierId', supplierId);
            const localVarPath = `/suppliers/{supplierId}/payment-providers/walletsv2`
                .replace(`{${"supplierId"}}`, encodeURIComponent(String(supplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bookingkit_v4_users_auth required
            // oauth required
            yield setOAuthToObject(localVarHeaderParameter, "bookingkit_v4_users_auth", [], configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create label
         * @param {string} supplierId
         * @param {CreateLabelRequest} createLabelRequest A required query parameter to set the new label name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLabel(supplierId, createLabelRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createLabel(supplierId, createLabelRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Search orders with a query building pattern
         * @param {string} supplierId
         * @param {CustomSearchOrderRequest} customSearchOrderRequest An array of BSQL objects
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customSearchOrder(supplierId, customSearchOrderRequest, pageSize, asc, nextPageToken, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customSearchOrder(supplierId, customSearchOrderRequest, pageSize, asc, nextPageToken, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete label
         * @param {string} supplierId
         * @param {string} labelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLabel(supplierId, labelId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteLabel(supplierId, labelId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * `account_status` can be one of the following:      *  - `ACTIVE`: The supplier is active and fully operative.      *  - `INCOMPLETE`: The supplier account is canceled. The account can be still accessed with limited functionalities.      *  - `CANCELED`: The supplier account is missing some required information. Until the status does not switch to active, this account has limited functionalities and can not receive orders.
         * @summary Gets current supplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserSupplier(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrentUserSupplier(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get total number of tickets for orders per day. Only orders with status: accepted, requested and reserved. Only active or requested tickets are counted.
         * @param {string} supplierId
         * @param {GetOrderStatsTicketCountRequest} getOrderStatsTicketCountRequest The filters to get the stats for
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [sortBy]
         * @param {string} [nextPageToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderStatsTicketCount(supplierId, getOrderStatsTicketCountRequest, pageSize, asc, sortBy, nextPageToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrderStatsTicketCount(supplierId, getOrderStatsTicketCountRequest, pageSize, asc, sortBy, nextPageToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get tickets value for orders per day
         * @param {string} supplierId
         * @param {GetOrderStatsTicketValueRequest} getOrderStatsTicketValueRequest The filters to get the stats for
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [sortBy]
         * @param {string} [nextPageToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderStatsTicketValue(supplierId, getOrderStatsTicketValueRequest, pageSize, asc, sortBy, nextPageToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOrderStatsTicketValue(supplierId, getOrderStatsTicketValueRequest, pageSize, asc, sortBy, nextPageToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersMe(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUsersMe(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get a widget
         * @param {string} widgetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidget(widgetId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWidget(widgetId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List all apps
         * @param {string} supplierId
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApps(supplierId, pageSize, asc, nextPageToken, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listApps(supplierId, pageSize, asc, nextPageToken, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List experience\'s availabilities
         * @param {string} supplierId
         * @param {string} experienceId
         * @param {string} localStartTime
         * @param {string} [localEndTime]
         * @param {string} [_options]
         * @param {string} [deltaSince]
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExperienceAvailabilities(supplierId, experienceId, localStartTime, localEndTime, _options, deltaSince, pageSize, asc, nextPageToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listExperienceAvailabilities(supplierId, experienceId, localStartTime, localEndTime, _options, deltaSince, pageSize, asc, nextPageToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List experiences
         * @param {string} supplierId
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExperiences(supplierId, pageSize, asc, nextPageToken, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listExperiences(supplierId, pageSize, asc, nextPageToken, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List labels
         * @param {string} supplierId
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabels(supplierId, pageSize, asc, nextPageToken, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listLabels(supplierId, pageSize, asc, nextPageToken, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List all modules
         * @param {string} supplierId
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listModules(supplierId, pageSize, asc, nextPageToken, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listModules(supplierId, pageSize, asc, nextPageToken, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List available suppliers
         * @param {string} [nameContains] An optional query parameter to filter the list
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSuppliers(nameContains, pageSize, asc, nextPageToken, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSuppliers(nameContains, pageSize, asc, nextPageToken, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Transactions|List for wallet
         * @param {string} supplierId
         * @param {string} walletId
         * @param {string} [types]
         * @param {string} [from]
         * @param {string} [to]
         * @param {string} [nextPageToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransactions(supplierId, walletId, types, from, to, nextPageToken, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listTransactions(supplierId, walletId, types, from, to, nextPageToken, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List widget\'s experiences
         * @param {string} widgetId
         * @param {string} [experienceIds]
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWidgetExperiences(widgetId, experienceIds, pageSize, asc, nextPageToken, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listWidgetExperiences(widgetId, experienceIds, pageSize, asc, nextPageToken, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List widget\'s experiences availabilities
         * @param {string} widgetId
         * @param {string} experienceId
         * @param {string} localStartTime
         * @param {string} [localEndTime]
         * @param {string} [_options]
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWidgetExperiencesAvailabilities(widgetId, experienceId, localStartTime, localEndTime, _options, pageSize, asc, nextPageToken, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listWidgetExperiencesAvailabilities(widgetId, experienceId, localStartTime, localEndTime, _options, pageSize, asc, nextPageToken, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Allows to edit an availability object
         * @param {string} supplierId
         * @param {string} experienceId
         * @param {string} availabilityId
         * @param {PatchAvailabilityRequest} patchAvailabilityRequest The fields and values to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchExperienceAvailability(supplierId, experienceId, availabilityId, patchAvailabilityRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.patchExperienceAvailability(supplierId, experienceId, availabilityId, patchAvailabilityRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List of payment options of the supplier
         * @param {string} supplierId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentOptionsGet(supplierId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentOptionsGet(supplierId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List of PaymentProviders of the supplier
         * @param {string} supplierId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentProviders(supplierId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentProviders(supplierId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Payout money from a wallet
         * @param {string} supplierId
         * @param {string} walletId
         * @param {CreatePayoutRequest} createPayoutRequest The fields and values to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutCreateV2(supplierId, walletId, createPayoutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.payoutCreateV2(supplierId, walletId, createPayoutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create a payout destination
         * @param {string} supplierId
         * @param {string} walletId
         * @param {CreatePayoutDestinationRequest} createPayoutDestinationRequest The fields and values to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutDestinationCreate(supplierId, walletId, createPayoutDestinationRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.payoutDestinationCreate(supplierId, walletId, createPayoutDestinationRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete payout destination
         * @param {string} supplierId
         * @param {string} walletId
         * @param {string} payoutDestinationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutDestinationDelete(supplierId, walletId, payoutDestinationId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.payoutDestinationDelete(supplierId, walletId, payoutDestinationId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary List payout destinations
         * @param {string} supplierId
         * @param {string} walletId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutDestinationList(supplierId, walletId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.payoutDestinationList(supplierId, walletId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Search coupons
         * @param {string} supplierId
         * @param {string} query
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCoupons(supplierId, query, pageSize, asc, nextPageToken, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchCoupons(supplierId, query, pageSize, asc, nextPageToken, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Search orders
         * @param {string} supplierId
         * @param {string} query
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {SearchOrdersSortByEnum} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrders(supplierId, query, pageSize, asc, nextPageToken, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchOrders(supplierId, query, pageSize, asc, nextPageToken, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Search vouchers
         * @param {string} supplierId
         * @param {string} query
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVouchers(supplierId, query, pageSize, asc, nextPageToken, sortBy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchVouchers(supplierId, query, pageSize, asc, nextPageToken, sortBy, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Sets current user supplier
         * @param {string} ident A required query parameter to set the new user supplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCurrentUserSupplier(ident, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setCurrentUserSupplier(ident, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Set payment options for the checkout
         * @param {string} supplierId
         * @param {SetPaymentOptionsRequest} setPaymentOptionsRequest A list of payment options to toggle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPaymentOptions(supplierId, setPaymentOptionsRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.setPaymentOptions(supplierId, setPaymentOptionsRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Schedule the switch of payment provider
         * @param {string} supplierId
         * @param {string} providerId
         * @param {SetActivationIntent} setActivationIntent Setting for switching the payment provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchPaymentProviders(supplierId, providerId, setActivationIntent, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.switchPaymentProviders(supplierId, providerId, setActivationIntent, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update label
         * @param {string} supplierId
         * @param {string} labelId
         * @param {UpdateLabelRequest} updateLabelRequest A required query parameter to update an existing label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLabel(supplierId, labelId, updateLabelRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateLabel(supplierId, labelId, updateLabelRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Wallets|List by supplier
         * @param {string} supplierId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wallets(supplierId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.wallets(supplierId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Wallets|List by supplier
         * @param {string} supplierId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        walletsV2(supplierId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.walletsV2(supplierId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DefaultApiFp(configuration);
    return {
        /**
         *
         * @summary Create label
         * @param {string} supplierId
         * @param {CreateLabelRequest} createLabelRequest A required query parameter to set the new label name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLabel(supplierId, createLabelRequest, options) {
            return localVarFp.createLabel(supplierId, createLabelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search orders with a query building pattern
         * @param {string} supplierId
         * @param {CustomSearchOrderRequest} customSearchOrderRequest An array of BSQL objects
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customSearchOrder(supplierId, customSearchOrderRequest, pageSize, asc, nextPageToken, sortBy, options) {
            return localVarFp.customSearchOrder(supplierId, customSearchOrderRequest, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete label
         * @param {string} supplierId
         * @param {string} labelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLabel(supplierId, labelId, options) {
            return localVarFp.deleteLabel(supplierId, labelId, options).then((request) => request(axios, basePath));
        },
        /**
         * `account_status` can be one of the following:      *  - `ACTIVE`: The supplier is active and fully operative.      *  - `INCOMPLETE`: The supplier account is canceled. The account can be still accessed with limited functionalities.      *  - `CANCELED`: The supplier account is missing some required information. Until the status does not switch to active, this account has limited functionalities and can not receive orders.
         * @summary Gets current supplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserSupplier(options) {
            return localVarFp.getCurrentUserSupplier(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get total number of tickets for orders per day. Only orders with status: accepted, requested and reserved. Only active or requested tickets are counted.
         * @param {string} supplierId
         * @param {GetOrderStatsTicketCountRequest} getOrderStatsTicketCountRequest The filters to get the stats for
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [sortBy]
         * @param {string} [nextPageToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderStatsTicketCount(supplierId, getOrderStatsTicketCountRequest, pageSize, asc, sortBy, nextPageToken, options) {
            return localVarFp.getOrderStatsTicketCount(supplierId, getOrderStatsTicketCountRequest, pageSize, asc, sortBy, nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get tickets value for orders per day
         * @param {string} supplierId
         * @param {GetOrderStatsTicketValueRequest} getOrderStatsTicketValueRequest The filters to get the stats for
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [sortBy]
         * @param {string} [nextPageToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderStatsTicketValue(supplierId, getOrderStatsTicketValueRequest, pageSize, asc, sortBy, nextPageToken, options) {
            return localVarFp.getOrderStatsTicketValue(supplierId, getOrderStatsTicketValueRequest, pageSize, asc, sortBy, nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersMe(options) {
            return localVarFp.getUsersMe(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a widget
         * @param {string} widgetId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWidget(widgetId, options) {
            return localVarFp.getWidget(widgetId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all apps
         * @param {string} supplierId
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listApps(supplierId, pageSize, asc, nextPageToken, sortBy, options) {
            return localVarFp.listApps(supplierId, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List experience\'s availabilities
         * @param {string} supplierId
         * @param {string} experienceId
         * @param {string} localStartTime
         * @param {string} [localEndTime]
         * @param {string} [_options]
         * @param {string} [deltaSince]
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExperienceAvailabilities(supplierId, experienceId, localStartTime, localEndTime, _options, deltaSince, pageSize, asc, nextPageToken, options) {
            return localVarFp.listExperienceAvailabilities(supplierId, experienceId, localStartTime, localEndTime, _options, deltaSince, pageSize, asc, nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List experiences
         * @param {string} supplierId
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExperiences(supplierId, pageSize, asc, nextPageToken, sortBy, options) {
            return localVarFp.listExperiences(supplierId, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List labels
         * @param {string} supplierId
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLabels(supplierId, pageSize, asc, nextPageToken, sortBy, options) {
            return localVarFp.listLabels(supplierId, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List all modules
         * @param {string} supplierId
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listModules(supplierId, pageSize, asc, nextPageToken, sortBy, options) {
            return localVarFp.listModules(supplierId, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List available suppliers
         * @param {string} [nameContains] An optional query parameter to filter the list
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSuppliers(nameContains, pageSize, asc, nextPageToken, sortBy, options) {
            return localVarFp.listSuppliers(nameContains, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Transactions|List for wallet
         * @param {string} supplierId
         * @param {string} walletId
         * @param {string} [types]
         * @param {string} [from]
         * @param {string} [to]
         * @param {string} [nextPageToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransactions(supplierId, walletId, types, from, to, nextPageToken, options) {
            return localVarFp.listTransactions(supplierId, walletId, types, from, to, nextPageToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List widget\'s experiences
         * @param {string} widgetId
         * @param {string} [experienceIds]
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWidgetExperiences(widgetId, experienceIds, pageSize, asc, nextPageToken, sortBy, options) {
            return localVarFp.listWidgetExperiences(widgetId, experienceIds, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List widget\'s experiences availabilities
         * @param {string} widgetId
         * @param {string} experienceId
         * @param {string} localStartTime
         * @param {string} [localEndTime]
         * @param {string} [_options]
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listWidgetExperiencesAvailabilities(widgetId, experienceId, localStartTime, localEndTime, _options, pageSize, asc, nextPageToken, sortBy, options) {
            return localVarFp.listWidgetExperiencesAvailabilities(widgetId, experienceId, localStartTime, localEndTime, _options, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Allows to edit an availability object
         * @param {string} supplierId
         * @param {string} experienceId
         * @param {string} availabilityId
         * @param {PatchAvailabilityRequest} patchAvailabilityRequest The fields and values to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchExperienceAvailability(supplierId, experienceId, availabilityId, patchAvailabilityRequest, options) {
            return localVarFp.patchExperienceAvailability(supplierId, experienceId, availabilityId, patchAvailabilityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List of payment options of the supplier
         * @param {string} supplierId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentOptionsGet(supplierId, options) {
            return localVarFp.paymentOptionsGet(supplierId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List of PaymentProviders of the supplier
         * @param {string} supplierId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentProviders(supplierId, options) {
            return localVarFp.paymentProviders(supplierId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Payout money from a wallet
         * @param {string} supplierId
         * @param {string} walletId
         * @param {CreatePayoutRequest} createPayoutRequest The fields and values to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutCreateV2(supplierId, walletId, createPayoutRequest, options) {
            return localVarFp.payoutCreateV2(supplierId, walletId, createPayoutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a payout destination
         * @param {string} supplierId
         * @param {string} walletId
         * @param {CreatePayoutDestinationRequest} createPayoutDestinationRequest The fields and values to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutDestinationCreate(supplierId, walletId, createPayoutDestinationRequest, options) {
            return localVarFp.payoutDestinationCreate(supplierId, walletId, createPayoutDestinationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete payout destination
         * @param {string} supplierId
         * @param {string} walletId
         * @param {string} payoutDestinationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutDestinationDelete(supplierId, walletId, payoutDestinationId, options) {
            return localVarFp.payoutDestinationDelete(supplierId, walletId, payoutDestinationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List payout destinations
         * @param {string} supplierId
         * @param {string} walletId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        payoutDestinationList(supplierId, walletId, options) {
            return localVarFp.payoutDestinationList(supplierId, walletId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search coupons
         * @param {string} supplierId
         * @param {string} query
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCoupons(supplierId, query, pageSize, asc, nextPageToken, sortBy, options) {
            return localVarFp.searchCoupons(supplierId, query, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search orders
         * @param {string} supplierId
         * @param {string} query
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {SearchOrdersSortByEnum} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrders(supplierId, query, pageSize, asc, nextPageToken, sortBy, options) {
            return localVarFp.searchOrders(supplierId, query, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search vouchers
         * @param {string} supplierId
         * @param {string} query
         * @param {number} [pageSize]
         * @param {boolean} [asc]
         * @param {string} [nextPageToken]
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchVouchers(supplierId, query, pageSize, asc, nextPageToken, sortBy, options) {
            return localVarFp.searchVouchers(supplierId, query, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Sets current user supplier
         * @param {string} ident A required query parameter to set the new user supplier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCurrentUserSupplier(ident, options) {
            return localVarFp.setCurrentUserSupplier(ident, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set payment options for the checkout
         * @param {string} supplierId
         * @param {SetPaymentOptionsRequest} setPaymentOptionsRequest A list of payment options to toggle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPaymentOptions(supplierId, setPaymentOptionsRequest, options) {
            return localVarFp.setPaymentOptions(supplierId, setPaymentOptionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Schedule the switch of payment provider
         * @param {string} supplierId
         * @param {string} providerId
         * @param {SetActivationIntent} setActivationIntent Setting for switching the payment provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        switchPaymentProviders(supplierId, providerId, setActivationIntent, options) {
            return localVarFp.switchPaymentProviders(supplierId, providerId, setActivationIntent, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update label
         * @param {string} supplierId
         * @param {string} labelId
         * @param {UpdateLabelRequest} updateLabelRequest A required query parameter to update an existing label
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLabel(supplierId, labelId, updateLabelRequest, options) {
            return localVarFp.updateLabel(supplierId, labelId, updateLabelRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Wallets|List by supplier
         * @param {string} supplierId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wallets(supplierId, options) {
            return localVarFp.wallets(supplierId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Wallets|List by supplier
         * @param {string} supplierId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        walletsV2(supplierId, options) {
            return localVarFp.walletsV2(supplierId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     *
     * @summary Create label
     * @param {string} supplierId
     * @param {CreateLabelRequest} createLabelRequest A required query parameter to set the new label name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createLabel(supplierId, createLabelRequest, options) {
        return DefaultApiFp(this.configuration).createLabel(supplierId, createLabelRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search orders with a query building pattern
     * @param {string} supplierId
     * @param {CustomSearchOrderRequest} customSearchOrderRequest An array of BSQL objects
     * @param {number} [pageSize]
     * @param {boolean} [asc]
     * @param {string} [nextPageToken]
     * @param {string} [sortBy]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    customSearchOrder(supplierId, customSearchOrderRequest, pageSize, asc, nextPageToken, sortBy, options) {
        return DefaultApiFp(this.configuration).customSearchOrder(supplierId, customSearchOrderRequest, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete label
     * @param {string} supplierId
     * @param {string} labelId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteLabel(supplierId, labelId, options) {
        return DefaultApiFp(this.configuration).deleteLabel(supplierId, labelId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * `account_status` can be one of the following:      *  - `ACTIVE`: The supplier is active and fully operative.      *  - `INCOMPLETE`: The supplier account is canceled. The account can be still accessed with limited functionalities.      *  - `CANCELED`: The supplier account is missing some required information. Until the status does not switch to active, this account has limited functionalities and can not receive orders.
     * @summary Gets current supplier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCurrentUserSupplier(options) {
        return DefaultApiFp(this.configuration).getCurrentUserSupplier(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get total number of tickets for orders per day. Only orders with status: accepted, requested and reserved. Only active or requested tickets are counted.
     * @param {string} supplierId
     * @param {GetOrderStatsTicketCountRequest} getOrderStatsTicketCountRequest The filters to get the stats for
     * @param {number} [pageSize]
     * @param {boolean} [asc]
     * @param {string} [sortBy]
     * @param {string} [nextPageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getOrderStatsTicketCount(supplierId, getOrderStatsTicketCountRequest, pageSize, asc, sortBy, nextPageToken, options) {
        return DefaultApiFp(this.configuration).getOrderStatsTicketCount(supplierId, getOrderStatsTicketCountRequest, pageSize, asc, sortBy, nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get tickets value for orders per day
     * @param {string} supplierId
     * @param {GetOrderStatsTicketValueRequest} getOrderStatsTicketValueRequest The filters to get the stats for
     * @param {number} [pageSize]
     * @param {boolean} [asc]
     * @param {string} [sortBy]
     * @param {string} [nextPageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getOrderStatsTicketValue(supplierId, getOrderStatsTicketValueRequest, pageSize, asc, sortBy, nextPageToken, options) {
        return DefaultApiFp(this.configuration).getOrderStatsTicketValue(supplierId, getOrderStatsTicketValueRequest, pageSize, asc, sortBy, nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getUsersMe(options) {
        return DefaultApiFp(this.configuration).getUsersMe(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a widget
     * @param {string} widgetId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getWidget(widgetId, options) {
        return DefaultApiFp(this.configuration).getWidget(widgetId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all apps
     * @param {string} supplierId
     * @param {number} [pageSize]
     * @param {boolean} [asc]
     * @param {string} [nextPageToken]
     * @param {string} [sortBy]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listApps(supplierId, pageSize, asc, nextPageToken, sortBy, options) {
        return DefaultApiFp(this.configuration).listApps(supplierId, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List experience\'s availabilities
     * @param {string} supplierId
     * @param {string} experienceId
     * @param {string} localStartTime
     * @param {string} [localEndTime]
     * @param {string} [_options]
     * @param {string} [deltaSince]
     * @param {number} [pageSize]
     * @param {boolean} [asc]
     * @param {string} [nextPageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listExperienceAvailabilities(supplierId, experienceId, localStartTime, localEndTime, _options, deltaSince, pageSize, asc, nextPageToken, options) {
        return DefaultApiFp(this.configuration).listExperienceAvailabilities(supplierId, experienceId, localStartTime, localEndTime, _options, deltaSince, pageSize, asc, nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List experiences
     * @param {string} supplierId
     * @param {number} [pageSize]
     * @param {boolean} [asc]
     * @param {string} [nextPageToken]
     * @param {string} [sortBy]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listExperiences(supplierId, pageSize, asc, nextPageToken, sortBy, options) {
        return DefaultApiFp(this.configuration).listExperiences(supplierId, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List labels
     * @param {string} supplierId
     * @param {number} [pageSize]
     * @param {boolean} [asc]
     * @param {string} [nextPageToken]
     * @param {string} [sortBy]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listLabels(supplierId, pageSize, asc, nextPageToken, sortBy, options) {
        return DefaultApiFp(this.configuration).listLabels(supplierId, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List all modules
     * @param {string} supplierId
     * @param {number} [pageSize]
     * @param {boolean} [asc]
     * @param {string} [nextPageToken]
     * @param {string} [sortBy]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listModules(supplierId, pageSize, asc, nextPageToken, sortBy, options) {
        return DefaultApiFp(this.configuration).listModules(supplierId, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List available suppliers
     * @param {string} [nameContains] An optional query parameter to filter the list
     * @param {number} [pageSize]
     * @param {boolean} [asc]
     * @param {string} [nextPageToken]
     * @param {string} [sortBy]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listSuppliers(nameContains, pageSize, asc, nextPageToken, sortBy, options) {
        return DefaultApiFp(this.configuration).listSuppliers(nameContains, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Transactions|List for wallet
     * @param {string} supplierId
     * @param {string} walletId
     * @param {string} [types]
     * @param {string} [from]
     * @param {string} [to]
     * @param {string} [nextPageToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listTransactions(supplierId, walletId, types, from, to, nextPageToken, options) {
        return DefaultApiFp(this.configuration).listTransactions(supplierId, walletId, types, from, to, nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List widget\'s experiences
     * @param {string} widgetId
     * @param {string} [experienceIds]
     * @param {number} [pageSize]
     * @param {boolean} [asc]
     * @param {string} [nextPageToken]
     * @param {string} [sortBy]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listWidgetExperiences(widgetId, experienceIds, pageSize, asc, nextPageToken, sortBy, options) {
        return DefaultApiFp(this.configuration).listWidgetExperiences(widgetId, experienceIds, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List widget\'s experiences availabilities
     * @param {string} widgetId
     * @param {string} experienceId
     * @param {string} localStartTime
     * @param {string} [localEndTime]
     * @param {string} [_options]
     * @param {number} [pageSize]
     * @param {boolean} [asc]
     * @param {string} [nextPageToken]
     * @param {string} [sortBy]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listWidgetExperiencesAvailabilities(widgetId, experienceId, localStartTime, localEndTime, _options, pageSize, asc, nextPageToken, sortBy, options) {
        return DefaultApiFp(this.configuration).listWidgetExperiencesAvailabilities(widgetId, experienceId, localStartTime, localEndTime, _options, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Allows to edit an availability object
     * @param {string} supplierId
     * @param {string} experienceId
     * @param {string} availabilityId
     * @param {PatchAvailabilityRequest} patchAvailabilityRequest The fields and values to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    patchExperienceAvailability(supplierId, experienceId, availabilityId, patchAvailabilityRequest, options) {
        return DefaultApiFp(this.configuration).patchExperienceAvailability(supplierId, experienceId, availabilityId, patchAvailabilityRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List of payment options of the supplier
     * @param {string} supplierId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    paymentOptionsGet(supplierId, options) {
        return DefaultApiFp(this.configuration).paymentOptionsGet(supplierId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List of PaymentProviders of the supplier
     * @param {string} supplierId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    paymentProviders(supplierId, options) {
        return DefaultApiFp(this.configuration).paymentProviders(supplierId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Payout money from a wallet
     * @param {string} supplierId
     * @param {string} walletId
     * @param {CreatePayoutRequest} createPayoutRequest The fields and values to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    payoutCreateV2(supplierId, walletId, createPayoutRequest, options) {
        return DefaultApiFp(this.configuration).payoutCreateV2(supplierId, walletId, createPayoutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a payout destination
     * @param {string} supplierId
     * @param {string} walletId
     * @param {CreatePayoutDestinationRequest} createPayoutDestinationRequest The fields and values to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    payoutDestinationCreate(supplierId, walletId, createPayoutDestinationRequest, options) {
        return DefaultApiFp(this.configuration).payoutDestinationCreate(supplierId, walletId, createPayoutDestinationRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete payout destination
     * @param {string} supplierId
     * @param {string} walletId
     * @param {string} payoutDestinationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    payoutDestinationDelete(supplierId, walletId, payoutDestinationId, options) {
        return DefaultApiFp(this.configuration).payoutDestinationDelete(supplierId, walletId, payoutDestinationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List payout destinations
     * @param {string} supplierId
     * @param {string} walletId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    payoutDestinationList(supplierId, walletId, options) {
        return DefaultApiFp(this.configuration).payoutDestinationList(supplierId, walletId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search coupons
     * @param {string} supplierId
     * @param {string} query
     * @param {number} [pageSize]
     * @param {boolean} [asc]
     * @param {string} [nextPageToken]
     * @param {string} [sortBy]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    searchCoupons(supplierId, query, pageSize, asc, nextPageToken, sortBy, options) {
        return DefaultApiFp(this.configuration).searchCoupons(supplierId, query, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search orders
     * @param {string} supplierId
     * @param {string} query
     * @param {number} [pageSize]
     * @param {boolean} [asc]
     * @param {string} [nextPageToken]
     * @param {SearchOrdersSortByEnum} [sortBy]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    searchOrders(supplierId, query, pageSize, asc, nextPageToken, sortBy, options) {
        return DefaultApiFp(this.configuration).searchOrders(supplierId, query, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search vouchers
     * @param {string} supplierId
     * @param {string} query
     * @param {number} [pageSize]
     * @param {boolean} [asc]
     * @param {string} [nextPageToken]
     * @param {string} [sortBy]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    searchVouchers(supplierId, query, pageSize, asc, nextPageToken, sortBy, options) {
        return DefaultApiFp(this.configuration).searchVouchers(supplierId, query, pageSize, asc, nextPageToken, sortBy, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Sets current user supplier
     * @param {string} ident A required query parameter to set the new user supplier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    setCurrentUserSupplier(ident, options) {
        return DefaultApiFp(this.configuration).setCurrentUserSupplier(ident, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Set payment options for the checkout
     * @param {string} supplierId
     * @param {SetPaymentOptionsRequest} setPaymentOptionsRequest A list of payment options to toggle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    setPaymentOptions(supplierId, setPaymentOptionsRequest, options) {
        return DefaultApiFp(this.configuration).setPaymentOptions(supplierId, setPaymentOptionsRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Schedule the switch of payment provider
     * @param {string} supplierId
     * @param {string} providerId
     * @param {SetActivationIntent} setActivationIntent Setting for switching the payment provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    switchPaymentProviders(supplierId, providerId, setActivationIntent, options) {
        return DefaultApiFp(this.configuration).switchPaymentProviders(supplierId, providerId, setActivationIntent, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update label
     * @param {string} supplierId
     * @param {string} labelId
     * @param {UpdateLabelRequest} updateLabelRequest A required query parameter to update an existing label
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateLabel(supplierId, labelId, updateLabelRequest, options) {
        return DefaultApiFp(this.configuration).updateLabel(supplierId, labelId, updateLabelRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Wallets|List by supplier
     * @param {string} supplierId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    wallets(supplierId, options) {
        return DefaultApiFp(this.configuration).wallets(supplierId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Wallets|List by supplier
     * @param {string} supplierId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    walletsV2(supplierId, options) {
        return DefaultApiFp(this.configuration).walletsV2(supplierId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * @export
 */
export const SearchOrdersSortByEnum = {
    Date: 'date'
};
